import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  facilityField: {
    width: '100%',
    maxWidth: 320,
    [theme.breakpoints.down('xs')]: {
      maxWidth: 'none',
    },
  },
  loadingCard: {
    marginBottom: theme.spacing(3),
  },
  doneTipBanner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(1.5, 2),
    marginTop: theme.spacing(3),
    borderRadius: 12,
    backgroundColor: '#F4F6F8',
    border: '1px solid #D5DDE2',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  doneTipText: {
    fontSize: '0.875rem',
    lineHeight: 1.4,
    color: '#172024',
    margin: 0,
  },
}))

export default useStyles
